import React from "react";
import { Grid, Card, CardContent, Typography, Box, Button } from "@mui/material";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Legend as BarLegend } from "recharts";
import { Add, Assignment, CheckCircle, HourglassEmpty } from "@mui/icons-material";

const leadStatusData = [
	{ name: "Novos", value: 30 },
	{ name: "Em contato", value: 20 },
	{ name: "Qualificados", value: 15 },
	{ name: "Convertidos", value: 10 },
];

const dailyLeadsData = [
	{ day: "Seg", leads: 5 },
	{ day: "Ter", leads: 10 },
	{ day: "Qua", leads: 7 },
	{ day: "Qui", leads: 15 },
	{ day: "Sex", leads: 12 },
];

const COLORS = ["#3c5f97", "#23bdb8", "#34443d", "#f9900e"];

const DashboardSDR = () => {
	return (
		<Box sx={{ p: 3 }} className="mt-9">
			<Typography variant="h4" gutterBottom fontWeight="bold">
				Dashboard SDR - Captura de Leads
			</Typography>

			<Grid container spacing={3}>
				{/* KPIs Cards */}
				<Grid item xs={12} sm={6} md={3}>
					<Card
						sx={{
							background: "linear-gradient(135deg, #3c5f97 0%, #57718f 100%)",
							color: "white",
							boxShadow: 3,
						}}
					>
						<CardContent>
							<Typography variant="h6">Novos Leads</Typography>
							<Typography variant="h4" fontWeight="bold">
								30
							</Typography>
						</CardContent>
					</Card>
				</Grid>

				<Grid item xs={12} sm={6} md={3}>
					<Card
						sx={{
							background: "linear-gradient(135deg, #23bdb8 0%, #43e794 100%)",
							color: "white",
							boxShadow: 3,
						}}
					>
						<CardContent>
							<Typography variant="h6">Em Contato</Typography>
							<Typography variant="h4" fontWeight="bold">
								20
							</Typography>
						</CardContent>
					</Card>
				</Grid>

				<Grid item xs={12} sm={6} md={3}>
					<Card
						sx={{
							background: "linear-gradient(135deg, #34443d 0%, #43e794 100%)",
							color: "white",
							boxShadow: 3,
						}}
					>
						<CardContent>
							<Typography variant="h6">Qualificados</Typography>
							<Typography variant="h4" fontWeight="bold">
								15
							</Typography>
						</CardContent>
					</Card>
				</Grid>

				<Grid item xs={12} sm={6} md={3}>
					<Card
						sx={{
							background: "linear-gradient(to right, #f9900e, #ffba56)",
							color: "white",
							boxShadow: 3,
						}}
					>
						<CardContent>
							<Typography variant="h6">Convertidos</Typography>
							<Typography variant="h4" fontWeight="bold">
								10
							</Typography>
						</CardContent>
					</Card>
				</Grid>

				{/* Pie Chart - Status dos Leads */}
				<Grid item xs={12} md={6}>
					<Card sx={{ boxShadow: 3 }}>
						<CardContent>
							<Typography variant="h6" gutterBottom>
								Status dos Leads
							</Typography>
							<ResponsiveContainer width="100%" height={300}>
								<PieChart>
									<Pie data={leadStatusData} dataKey="value" nameKey="name" outerRadius={90} label>
										{COLORS.map((color, index) => (
											<Cell key={`cell-${index}`} fill={color} />
										))}
									</Pie>
									<Tooltip />
									<Legend
										verticalAlign="bottom"
										align="center"
										iconType="circle"
										wrapperStyle={{ fontSize: "14px" }}
									/>
								</PieChart>
							</ResponsiveContainer>
						</CardContent>
					</Card>
				</Grid>

				{/* Bar Chart - Leads por Dia */}
				<Grid item xs={12} md={6}>
					<Card sx={{ boxShadow: 3 }}>
						<CardContent>
							<Typography variant="h6" gutterBottom>
								Leads Capturados por Dia
							</Typography>
							<ResponsiveContainer width="100%" height={300}>
								<BarChart data={dailyLeadsData}>
									<defs>
										<linearGradient id="barColor" x1="0" y1="0" x2="0" y2="1">
											<stop offset="5%" stopColor="#3c5f97" stopOpacity={0.9} />
											<stop offset="95%" stopColor="#57718f" stopOpacity={0.7} />
										</linearGradient>
									</defs>
									<CartesianGrid strokeDasharray="3 3" />
									<XAxis dataKey="day" />
									<YAxis />
									<Tooltip />
									<BarLegend />
									<Bar dataKey="leads" fill="url(#barColor)" radius={[4, 4, 0, 0]} />
								</BarChart>
							</ResponsiveContainer>
						</CardContent>
					</Card>
				</Grid>

				{/* Tarefas Pendentes */}
				<Grid item xs={12}>
					<Card sx={{ boxShadow: 3 }}>
						<CardContent>
							<Typography variant="h6" gutterBottom>
								Tarefas Pendentes
							</Typography>
							<Box display="flex" gap={2} flexWrap="wrap">
								<Button
									variant="outlined"
									sx={{ color: "#3c5f97", borderColor: "#3c5f97" }}
									startIcon={<Assignment />}
								>
									Ligar para Leads
								</Button>
								<Button
									variant="outlined"
									sx={{ color: "#f9900e", borderColor: "#f9900e" }}
									startIcon={<HourglassEmpty />}
								>
									Aguardar Resposta
								</Button>
								<Button
									variant="outlined"
									sx={{ color: "#23bdb8", borderColor: "#23bdb8" }}
									startIcon={<CheckCircle />}
								>
									Leads Qualificados
								</Button>
								<Button
									variant="contained"
									sx={{
										background: "linear-gradient(135deg, #3c5f97, #57718f)",
										color: "white",
									}}
									startIcon={<Add />}
								>
									Novo Lead
								</Button>
							</Box>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</Box>
	);
};

export default DashboardSDR;
